import React, { useState, useEffect } from "react";
import "./Overview.css";
import { Target, TrendingUp, UserCheck } from "lucide-react";
import PromotionChart from "./PromotionChart";
import PromotionFeatures from "./PromotionFeatures";
import PromotionFeaturesgroth from "./PromotionFeaturesgroth";
import Promotionspricingdetails from "./Promotionspricingdetails";
import Pricingsectionparticular from "./Pricingsectionparticular";
import AddNewModal from "./AddNewModal"
import { PromotionsService } from "../../../Servicefile/PromotionsService";
// 👇 Top-level tabs. `id` must match the category keys used inside
// Pricingsectionparticular's `pricingPlans` object (branding/leads/offers/digital/combos).
const MAIN_TABS = [
  { id: "overview", label: "Overview" },
  { id: "branding", label: "Branding" },
  { id: "leads", label: "Leads" },
  { id: "offers", label: "Offers" },
  { id: "digital", label: "Digital Screens" },
  // { id: "combos", label: "Combos" },
];

// 👇 Shared style tokens reused across the different category layouts below
const ORANGE = "#e66d33";
const heroWrap = { padding: "60px 24px", margin: "0 auto" };
const eyebrow = {
  display: "inline-block",
  fontSize: 12,
  fontWeight: 700,
  letterSpacing: "1px",
  color: ORANGE,
  background: "#fff3ec",
  padding: "6px 14px",
  borderRadius: 20,
  marginBottom: 16,
};
const cardShadow = "0 10px 30px rgba(17,24,39,0.08)";

const Overview = ({
  title,
  onNavigate,
  onGetStarted
}) => {

  const [showPricing, setShowPricing] = useState(false);
  const [selectedFeature, setSelectedFeature] = useState(null);
  const [activeMainTab, setActiveMainTab] = useState("overview"); // 👈 NEW
  const [hideOverviewChrome, setHideOverviewChrome] = useState(false); // 👈 NEW
  const [overviewData, setOverviewData] = useState([]);
  const [loadingOverview, setLoadingOverview] = useState(true);
  const [overviewError, setOverviewError] = useState("");
  const [showAddModal, setShowAddModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedOverview, setSelectedOverview] = useState(null);
  const [showCategoryAddModal, setShowCategoryAddModal] = useState(false);
  const [brandingData, setBrandingData] = useState([]);
  const [loadingBranding, setLoadingBranding] = useState(true);
  const [brandingError, setBrandingError] = useState("");

  const [leadsData, setLeadsData] = useState([]);
  const [loadingLeads, setLoadingLeads] = useState(true);
  const [leadsError, setLeadsError] = useState("");

  const [offersData, setOffersData] = useState([]);
  const [loadingOffers, setLoadingOffers] = useState(true);
  const [offersError, setOffersError] = useState("");

  const [digitalData, setDigitalData] = useState([]);
  const [loadingDigital, setLoadingDigital] = useState(true);
  const [digitalError, setDigitalError] = useState("");
  const [addFormData, setAddFormData] = useState({
    title: "",
    description: "",
    image: null,
  });
  const [imagePreview, setImagePreview] = useState(null);

  const fetchOverviewData = async () => {
    try {
      setLoadingOverview(true);
      setOverviewError("");

      const response = await PromotionsService.getOverviews();

      ////console.log("Overview API response:", response);

      const overviewList = Array.isArray(response)
        ? response
        : Array.isArray(response?.data)
          ? response.data
          : [];

      // Only get OVERVIEW type
      const filteredOverview = overviewList.filter(
        (item) => item?.type === "OVERVIEW"
      );

      setOverviewData(filteredOverview);

    } catch (error) {
      console.error("Failed to fetch overview:", error);

      setOverviewError(
        error?.response?.data?.message ||
        error?.message ||
        "Failed to load overview data"
      );

      setOverviewData([]);

    } finally {
      setLoadingOverview(false);
    }
  };

  useEffect(() => {
    fetchOverviewData();
  }, []);



  const handleAddFormChange = (e) => {
    const { name, value } = e.target;
    setAddFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setAddFormData((prev) => ({ ...prev, image: file }));
      setImagePreview(URL.createObjectURL(file));
    }
  };
  const handleAddOverview = () => {
    setIsEditMode(false);
    setSelectedOverview(null);

    setAddFormData({
      title: "",
      description: "",
      image: null,
    });

    setImagePreview(null);

    setShowAddModal(true);
  };
  const handleAddFormSubmit = (e) => {
    e.preventDefault();
    //console.log("New item submitted:", addFormData);
    // TODO: send addFormData (use FormData if uploading the image to an API)
    setShowAddModal(false);
    setAddFormData({ title: "", description: "", image: null });
    setImagePreview(null);
  };

  const handleEditOverview = () => {
    if (!overviewData || overviewData.length === 0) {
      return;
    }

    // Get the existing OVERVIEW record
    const overview = overviewData[0];

    //console.log("Editing overview:", overview);
    //console.log("Editing overview ID:", overview.id);

    setIsEditMode(true);
    setSelectedOverview(overview);

    // Open modal
    setShowAddModal(true);
  };
  const getActiveCategoryData = () => {
    switch (activeMainTab) {
      case "branding":
        return brandingData;

      case "leads":
        return leadsData;

      case "offers":
        return offersData;

      case "digital":
        return digitalData;

      default:
        return [];
    }
  };

  const handleCreateCampaign = () => {
    if (onNavigate) {
      onNavigate("CREATE CAMPAIGN");
    }
  };

  const handleViewAnalytics = () => {
    if (onNavigate) {
      onNavigate("ANALYTICS");
    }
  };

  const handleExplore = (feature) => {
    //console.log("Feature received in Overview:", feature);

    setSelectedFeature(feature);
    setShowPricing(true);
  };
  // ---- BRANDING ----
  const fetchBrandingData = async () => {
    try {
      setLoadingBranding(true);
      setBrandingError("");

      const response = await PromotionsService.getOverviews();

      const overviewList = Array.isArray(response)
        ? response
        : Array.isArray(response?.data)
          ? response.data
          : Array.isArray(response?.content)
            ? response.content
            : [];

      //console.log("Raw overviews response:", response);

      const filteredBranding = overviewList.filter(
        (item) => item?.type?.toString().trim().toUpperCase() === "BRANDING"
      );

      setBrandingData(filteredBranding);

    } catch (error) {
      console.error("Failed to fetch branding data:", error);
      setBrandingError(
        error?.response?.data?.message || error?.message || "Failed to load branding data"
      );
      setBrandingData([]);
    } finally {
      setLoadingBranding(false);
    }
  };

  useEffect(() => {
    fetchBrandingData();
  }, []);

  // ---- LEADS ----
  const fetchLeadsData = async () => {
    try {
      setLoadingLeads(true);
      setLeadsError("");

      const response = await PromotionsService.getOverviews();

      const overviewList = Array.isArray(response)
        ? response
        : Array.isArray(response?.data)
          ? response.data
          : [];

      const filteredLeads = overviewList.filter(
        (item) => item?.type === "LEADS"
      );

      setLeadsData(filteredLeads);

    } catch (error) {
      console.error("Failed to fetch leads data:", error);
      setLeadsError(
        error?.response?.data?.message || error?.message || "Failed to load leads data"
      );
      setLeadsData([]);
    } finally {
      setLoadingLeads(false);
    }
  };

  useEffect(() => {
    fetchLeadsData();
  }, []);

  // ---- OFFERS ----
  // ---- OFFERS ----
  const fetchOffersData = async () => {
    try {
      setLoadingOffers(true);
      setOffersError("");

      const response = await PromotionsService.getOverviews();

      const overviewList = Array.isArray(response)
        ? response
        : Array.isArray(response?.data)
          ? response.data
          : Array.isArray(response?.content)
            ? response.content
            : [];

      const filteredOffers = overviewList.filter(
        (item) => item?.type?.toString().trim().toUpperCase() === "OFFERS"
      );

      setOffersData(filteredOffers);

    } catch (error) {
      console.error("Failed to fetch offers data:", error);
      setOffersError(
        error?.response?.data?.message || error?.message || "Failed to load offers data"
      );
      setOffersData([]);
    } finally {
      setLoadingOffers(false);
    }
  };

  useEffect(() => {
    fetchOffersData();
  }, []);

  // ---- DIGITAL SCREENS ----
  const fetchDigitalData = async () => {
    try {
      setLoadingDigital(true);
      setDigitalError("");

      const response = await PromotionsService.getOverviews();

      const overviewList = Array.isArray(response)
        ? response
        : Array.isArray(response?.data)
          ? response.data
          : Array.isArray(response?.content)
            ? response.content
            : [];

      const filteredDigital = overviewList.filter(
        (item) => item?.type?.toString().trim().toUpperCase() === "DIGITAL"
      );

      setDigitalData(filteredDigital);

    } catch (error) {
      console.error("Failed to fetch digital screens data:", error);
      setDigitalError(
        error?.response?.data?.message || error?.message || "Failed to load digital screens data"
      );
      setDigitalData([]);
    } finally {
      setLoadingDigital(false);
    }
  };

  useEffect(() => {
    fetchDigitalData();
  }, []);


  // Shared tab bar, rendered above everything else
  const renderMainTabs = () => (
    <div
      style={{
        display: "flex",
        gap: "12px",
        flexWrap: "wrap",
        padding: "16px 0px 0",
      }}
    >
      {MAIN_TABS.map((tab) => (
        <button
          key={tab.id}
          onClick={() => {
            setActiveMainTab(tab.id);
            setShowPricing(false);       // reset the "explore feature" flow
            setSelectedFeature(null);
            setHideOverviewChrome(false);
          }}
          style={{
            padding: "12px 26px",
            borderRadius: "24px",
            border: activeMainTab === tab.id ? "none" : "1px solid #d1d5db",
            background: activeMainTab === tab.id ? "#e66d33" : "#fff",
            color: activeMainTab === tab.id ? "#fff" : "#374151",
            cursor: "pointer",
            fontWeight: 600,
            fontSize: "16px",
            transition: "all 0.2s ease",
          }}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );

  // ===================== BRANDING =====================
  const renderBrandingHero = () => {

    const channels = [
      { icon: "fas fa-bell", title: "In-App Popup", desc: "Grab attention the moment customers open your app" },
      { icon: "fas fa-image", title: "Banner", desc: "Homepage placement seen on every visit" },
      { icon: "fas fa-tag", title: "Deals", desc: "Featured placement in your deals section" },
      { icon: "fas fa-shopping-cart", title: "Checkout", desc: "The last thing customers see before they order" },
    ];

    const hasBrandingData = brandingData.length > 0;
    const brandingItem = hasBrandingData ? brandingData[0] : null;

    return (
      <section style={heroWrap}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 40, alignItems: "center" }}>
          <div style={{ flex: "1 1 380px" }}>
            <span style={eyebrow}>BRANDING CAMPAIGNS</span>

            {loadingBranding ? (
              <h1 style={{ fontSize: 40, fontWeight: 800, color: "#0f172a", margin: "0 0 16px", lineHeight: 1.2 }}>
                Loading...
              </h1>
            ) : brandingError ? (
              <>
                <h1 style={{ fontSize: 40, fontWeight: 800, color: "#0f172a", margin: "0 0 16px", lineHeight: 1.2 }}>
                  Unable to load Branding
                </h1>
                <p style={{ fontSize: 16, color: "#6b7280", maxWidth: 460, lineHeight: 1.6 }}>
                  {brandingError}
                </p>
              </>
            ) : hasBrandingData ? (
              <>
                <h1 style={{ fontSize: 40, fontWeight: 800, color: "#0f172a", margin: "0 0 16px", lineHeight: 1.2 }}>
                  {brandingItem.title}
                </h1>
                <p style={{ fontSize: 16, color: "#6b7280", maxWidth: 460, lineHeight: 1.6 }}>
                  {brandingItem.description}
                </p>

                {Array.isArray(brandingItem.featureDescription) &&
                  brandingItem.featureDescription.length > 0 && (
                    <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 16 }}>
                      {brandingItem.featureDescription.map((feature, index) => (
                        <span key={index} style={{ fontSize: 14, color: "#374151" }}>
                          <i className="fas fa-check-circle" style={{ color: ORANGE, marginRight: 8 }}></i>
                          {feature}
                        </span>
                      ))}
                    </div>
                  )}
              </>
            ) : (
              <>
                <h1 style={{ fontSize: 40, fontWeight: 800, color: "#0f172a", margin: "0 0 16px", lineHeight: 1.2 }}>
                  Build Your Brand <span style={{ color: ORANGE }}>Everywhere</span> Customers Look
                </h1>
                <p style={{ fontSize: 16, color: "#6b7280", maxWidth: 460, lineHeight: 1.6 }}>
                  Run popups, banners, deals and checkout promotions to put your business
                  in front of customers at every step of their journey.
                </p>
              </>
            )}

            <div style={{ display: "flex", gap: 0, marginTop: 28, flexWrap: "wrap" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 14, padding: "4px 28px 4px 0" }}>
                <div style={{
                  width: 40, height: 40, borderRadius: 10,
                  background: "#eef2ff", display: "flex",
                  alignItems: "center", justifyContent: "center", flexShrink: 0,
                }}>
                  <Target size={20} color="#4338ca" />
                </div>
                <div>
                  <div style={{ fontSize: 28, fontWeight: 800, color: "#0f172a", lineHeight: 1, fontVariantNumeric: "tabular-nums" }}>4x</div>
                  <div style={{ fontSize: 13, color: "#6b7280", marginTop: 4 }}>Touchpoints covered</div>
                </div>
              </div>

              <div style={{ width: 1, background: "#e5e7eb", alignSelf: "stretch", margin: "0 4px" }} />

              <div style={{ display: "flex", alignItems: "center", gap: 14, padding: "4px 0 4px 28px" }}>
                <div style={{
                  width: 40, height: 40, borderRadius: 10,
                  background: "#ecfdf5", display: "flex",
                  alignItems: "center", justifyContent: "center", flexShrink: 0,
                }}>
                  <TrendingUp size={20} color="#059669" />
                </div>
                <div>
                  <div style={{ fontSize: 28, fontWeight: 800, color: "#0f172a", lineHeight: 1, fontVariantNumeric: "tabular-nums" }}>+180%</div>
                  <div style={{ fontSize: 13, color: "#6b7280", marginTop: 4 }}>Brand recall</div>
                </div>
              </div>
            </div>
          </div>

          <div style={{ flex: "1 1 320px", position: "relative" }}>
            {hasBrandingData && Array.isArray(brandingItem.imageUrls) && brandingItem.imageUrls.length > 0 ? (
              <div
                style={{
                  width: "100%",
                  height: "320px",
                  overflow: "hidden",
                  borderRadius: 20,
                  boxShadow: cardShadow,
                }}
              >
                <img
                  src={brandingItem.imageUrls[0]}
                  alt={brandingItem.title || "Branding"}
                  style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                />
              </div>
            ) : (
              <div
                style={{
                  position: "relative",
                  background: "#fff9f5",
                  border: `1.5px dashed #f0c8ae`,
                  borderRadius: 20,
                  padding: 28,
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: -14,
                    right: 20,
                    background: ORANGE,
                    color: "#fff",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: "0.5px",
                    padding: "6px 14px",
                    borderRadius: 20,
                    boxShadow: "0 8px 18px rgba(230,109,51,0.35)",
                  }}
                >
                  EVERY TOUCHPOINT
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                  {channels.map((c, i) => (
                    <div
                      key={i}
                      style={{
                        background: "#fff",
                        border: "1px solid #f0f0f0",
                        borderRadius: 14,
                        padding: "18px 14px",
                        boxShadow: cardShadow,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        textAlign: "center",
                        gap: 10,
                      }}
                    >
                      <div
                        style={{
                          width: 38,
                          height: 38,
                          borderRadius: "50%",
                          background: "#fff3ec",
                          color: ORANGE,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: 16,
                        }}
                      >
                        <i className={c.icon}></i>
                      </div>
                      <span style={{ fontWeight: 700, fontSize: 13, color: "#1f2937" }}>{c.title}</span>
                      <p style={{ margin: 0, fontSize: 11, color: "#9ca3af", lineHeight: 1.4 }}>{c.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    );
  };

  // ===================== LEADS =====================
  // ===================== LEADS =====================
  const renderLeadsHero = () => {
    const tiers = [
      { label: "100 Leads", percent: "45%" },
      { label: "200 Leads", percent: "70%" },
      { label: "300 Leads", percent: "100%" },
    ];

    const hasLeadsData = leadsData.length > 0;
    const leadsItem = hasLeadsData ? leadsData[0] : null;

    return (
      <section style={heroWrap}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 40,
            alignItems: "center",
          }}
        >
          {/* ================= LEFT SIDE ================= */}
          <div style={{ flex: "1 1 380px" }}>
            <span style={eyebrow}>LEAD GENERATION</span>

            {loadingLeads ? (
              <>
                <h1
                  style={{
                    fontSize: 40,
                    fontWeight: 800,
                    color: "#0f172a",
                    margin: "0 0 16px",
                    lineHeight: 1.2,
                  }}
                >
                  Loading...
                </h1>

                <p
                  style={{
                    fontSize: 16,
                    color: "#6b7280",
                    maxWidth: 460,
                    lineHeight: 1.6,
                  }}
                >
                  Loading leads information...
                </p>
              </>
            ) : leadsError ? (
              <>
                <h1
                  style={{
                    fontSize: 40,
                    fontWeight: 800,
                    color: "#0f172a",
                    margin: "0 0 16px",
                    lineHeight: 1.2,
                  }}
                >
                  Unable to load Leads
                </h1>

                <p
                  style={{
                    fontSize: 16,
                    color: "#6b7280",
                    maxWidth: 460,
                    lineHeight: 1.6,
                  }}
                >
                  {leadsError}
                </p>
              </>
            ) : hasLeadsData ? (
              <>
                {/* API TITLE */}
                <h1
                  style={{
                    fontSize: 40,
                    fontWeight: 800,
                    color: "#0f172a",
                    margin: "0 0 16px",
                    lineHeight: 1.2,
                  }}
                >
                  {leadsItem.title}
                </h1>

                {/* API DESCRIPTION */}
                <p
                  style={{
                    fontSize: 16,
                    color: "#6b7280",
                    maxWidth: 460,
                    lineHeight: 1.6,
                  }}
                >
                  {leadsItem.description}
                </p>

                {/* API FEATURE DESCRIPTION */}
                {Array.isArray(leadsItem.featureDescription) &&
                  leadsItem.featureDescription.length > 0 && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 8,
                        marginTop: 16,
                      }}
                    >
                      {leadsItem.featureDescription.map(
                        (feature, index) => (
                          <span
                            key={index}
                            style={{
                              fontSize: 14,
                              color: "#374151",
                            }}
                          >
                            <i
                              className="fas fa-check-circle"
                              style={{
                                color: ORANGE,
                                marginRight: 8,
                              }}
                            ></i>

                            {feature}
                          </span>
                        )
                      )}
                    </div>
                  )}
              </>
            ) : (
              <>
                {/* DEFAULT DATA */}
                <h1
                  style={{
                    fontSize: 40,
                    fontWeight: 800,
                    color: "#0f172a",
                    margin: "0 0 16px",
                    lineHeight: 1.2,
                  }}
                >
                  Turn Visitors Into{" "}
                  <span style={{ color: ORANGE }}>
                    Verified
                  </span>{" "}
                  Leads
                </h1>

                <p
                  style={{
                    fontSize: 16,
                    color: "#6b7280",
                    maxWidth: 460,
                    lineHeight: 1.6,
                  }}
                >
                  Capture verified WhatsApp leads every month
                  and track every signup with real-time
                  analytics — pick the package that fits your
                  growth stage.
                </p>
              </>
            )}

            {/* ================= STATS ================= */}

            <div
              style={{
                display: "flex",
                gap: 0,
                marginTop: 28,
                flexWrap: "wrap",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 14,
                  padding: "4px 28px 4px 0",
                }}
              >
                <div
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: 10,
                    background: "#eef2ff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <TrendingUp
                    size={20}
                    color="#4338ca"
                  />
                </div>

                <div>
                  <div
                    style={{
                      fontSize: 28,
                      fontWeight: 800,
                      color: "#0f172a",
                      lineHeight: 1,
                      fontVariantNumeric: "tabular-nums",
                    }}
                  >
                    +250%
                  </div>

                  <div
                    style={{
                      fontSize: 13,
                      color: "#6b7280",
                      marginTop: 4,
                    }}
                  >
                    Lead growth
                  </div>
                </div>
              </div>

              <div
                style={{
                  width: 1,
                  background: "#e5e7eb",
                  alignSelf: "stretch",
                  margin: "0 4px",
                }}
              />

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 14,
                  padding: "4px 0 4px 28px",
                }}
              >
                <div
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: 10,
                    background: "#ecfdf5",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <UserCheck
                    size={20}
                    color="#059669"
                  />
                </div>

                <div>
                  <div
                    style={{
                      fontSize: 28,
                      fontWeight: 800,
                      color: "#0f172a",
                      lineHeight: 1,
                      fontVariantNumeric: "tabular-nums",
                    }}
                  >
                    +85%
                  </div>

                  <div
                    style={{
                      fontSize: 13,
                      color: "#6b7280",
                      marginTop: 4,
                    }}
                  >
                    Signup rate
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ================= RIGHT SIDE ================= */}

          <div
            style={{
              flex: "1 1 340px",
              display: "flex",
              flexDirection: "column",
              gap: 16,
            }}
          >
            {tiers.map((t, i) => (
              <div
                key={i}
                style={{
                  background: "#fff",
                  border: "1px solid #f0f0f0",
                  borderRadius: 14,
                  padding: "18px 22px",
                  boxShadow: cardShadow,
                  display: "flex",
                  alignItems: "center",
                  gap: 16,
                }}
              >
                <div
                  style={{
                    width: 44,
                    height: 44,
                    borderRadius: "50%",
                    background: "#fff3ec",
                    color: ORANGE,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 18,
                    flexShrink: 0,
                  }}
                >
                  <i className="fas fa-users"></i>
                </div>

                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 8,
                    }}
                  >
                    <span
                      style={{
                        fontWeight: 700,
                        color: "#1f2937",
                        fontSize: 14,
                      }}
                    >
                      {t.label}
                    </span>

                    <span
                      style={{
                        fontSize: 12,
                        color: "#9ca3af",
                      }}
                    >
                      / month
                    </span>
                  </div>

                  <div
                    style={{
                      height: 8,
                      background: "#f3f4f6",
                      borderRadius: 4,
                    }}
                  >
                    <div
                      style={{
                        height: 8,
                        width: t.percent,
                        background: ORANGE,
                        borderRadius: 4,
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  };

  // ===================== OFFERS =====================
  // ===================== OFFERS =====================
  const renderOffersHero = () => {
    const defaultTags = [
      "Coupons",
      "Flat Discounts",
      "Buy 1 Get 1",
      "Festival Offers",
      "Happy Hours",
    ];

    const hasOffersData = offersData.length > 0;
    const offersItem = hasOffersData ? offersData[0] : null;

    const offerFeatures =
      Array.isArray(offersItem?.featureDescription) &&
        offersItem.featureDescription.length > 0
        ? offersItem.featureDescription
        : defaultTags;

    return (
      <section style={heroWrap}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 40,
            alignItems: "center",
          }}
        >
          {/* ================= LEFT SIDE ================= */}

          <div style={{ flex: "1 1 380px" }}>
            <span style={eyebrow}>
              OFFERS &amp; DISCOUNTS
            </span>

            {/* ================= LOADING ================= */}

            {loadingOffers ? (
              <>
                <h1
                  style={{
                    fontSize: 40,
                    fontWeight: 800,
                    color: "#0f172a",
                    margin: "0 0 16px",
                    lineHeight: 1.2,
                  }}
                >
                  Loading...
                </h1>

                <p
                  style={{
                    fontSize: 16,
                    color: "#6b7280",
                    maxWidth: 460,
                    lineHeight: 1.6,
                  }}
                >
                  Loading offers information...
                </p>
              </>
            ) : offersError ? (
              <>
                <h1
                  style={{
                    fontSize: 40,
                    fontWeight: 800,
                    color: "#0f172a",
                    margin: "0 0 16px",
                    lineHeight: 1.2,
                  }}
                >
                  Unable to load Offers
                </h1>

                <p
                  style={{
                    fontSize: 16,
                    color: "#6b7280",
                    maxWidth: 460,
                    lineHeight: 1.6,
                  }}
                >
                  {offersError}
                </p>
              </>
            ) : hasOffersData ? (
              <>
                {/* ================= API TITLE ================= */}

                <h1
                  style={{
                    fontSize: 40,
                    fontWeight: 800,
                    color: "#0f172a",
                    margin: "0 0 16px",
                    lineHeight: 1.2,
                  }}
                >
                  {offersItem.title}
                </h1>

                {/* ================= API DESCRIPTION ================= */}

                <p
                  style={{
                    fontSize: 16,
                    color: "#6b7280",
                    maxWidth: 460,
                    lineHeight: 1.6,
                    marginBottom: 24,
                  }}
                >
                  {offersItem.description}
                </p>

                {/* ================= API FEATURES ================= */}

                {Array.isArray(offersItem.featureDescription) &&
                  offersItem.featureDescription.length > 0 && (
                    <div
                      style={{
                        display: "flex",
                        gap: 10,
                        flexWrap: "wrap",
                      }}
                    >
                      {offersItem.featureDescription.map(
                        (feature, index) => (
                          <span
                            key={index}
                            style={{
                              padding: "8px 16px",
                              borderRadius: 20,
                              border: "1px solid #e5e7eb",
                              fontSize: 13,
                              fontWeight: 600,
                              color: "#374151",
                              background: "#fff",
                            }}
                          >
                            {feature}
                          </span>
                        )
                      )}
                    </div>
                  )}
              </>
            ) : (
              <>
                {/* ================= DEFAULT ================= */}

                <h1
                  style={{
                    fontSize: 40,
                    fontWeight: 800,
                    color: "#0f172a",
                    margin: "0 0 16px",
                    lineHeight: 1.2,
                  }}
                >
                  Drive Sales with{" "}
                  <span style={{ color: ORANGE }}>
                    Irresistible
                  </span>{" "}
                  Offers
                </h1>

                <p
                  style={{
                    fontSize: 16,
                    color: "#6b7280",
                    maxWidth: 460,
                    lineHeight: 1.6,
                    marginBottom: 24,
                  }}
                >
                  Launch coupons, discounts, and Buy-1-Get-1
                  style deals that get customers ordering more,
                  more often.
                </p>

                <div
                  style={{
                    display: "flex",
                    gap: 10,
                    flexWrap: "wrap",
                  }}
                >
                  {defaultTags.map((tag, index) => (
                    <span
                      key={index}
                      style={{
                        padding: "8px 16px",
                        borderRadius: 20,
                        border: "1px solid #e5e7eb",
                        fontSize: 13,
                        fontWeight: 600,
                        color: "#374151",
                        background: "#fff",
                      }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </>
            )}
          </div>

          {/* ================= RIGHT SIDE ================= */}

          <div
            style={{
              flex: "1 1 340px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {hasOffersData &&
              Array.isArray(offersItem.imageUrls) &&
              offersItem.imageUrls.length > 0 ? (
              /* ================= API IMAGE ================= */

              <div
                style={{
                  width: "100%",
                  maxWidth: 380,
                  height: 320,
                  borderRadius: 24,
                  overflow: "hidden",
                  boxShadow: cardShadow,
                }}
              >
                <img
                  src={offersItem.imageUrls[0]}
                  alt={offersItem.title || "Offers"}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              </div>
            ) : (
              /* ================= DEFAULT OFFER CARD ================= */

              <div
                style={{
                  position: "relative",
                  width: "100%",
                  maxWidth: 380,
                  background: "#fff9f5",
                  border: "1.5px solid #f5dcc9",
                  borderRadius: 24,
                  padding: "40px 24px",
                  display: "flex",
                  justifyContent: "center",
                  boxShadow:
                    "0 10px 30px rgba(17,24,39,0.06)",
                }}
              >
                <div
                  style={{
                    position: "relative",
                    width: 300,
                    height: 300,
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      background: `linear-gradient(
                      135deg,
                      ${ORANGE},
                      #ff9a5c
                    )`,
                      clipPath:
                        "polygon(50% 0%, 61% 12%, 75% 4%, 79% 18%, 94% 14%, 93% 30%, 100% 39%, 90% 50%, 100% 61%, 93% 70%, 94% 86%, 79% 82%, 75% 96%, 61% 88%, 50% 100%, 39% 88%, 25% 96%, 21% 82%, 6% 86%, 7% 70%, 0% 61%, 10% 50%, 0% 39%, 7% 30%, 6% 14%, 21% 18%, 25% 4%, 39% 12%)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fff",
                      textAlign: "center",
                      boxShadow:
                        "0 20px 40px rgba(230,109,51,0.3)",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 13,
                        fontWeight: 700,
                        letterSpacing: "1px",
                        opacity: 0.85,
                      }}
                    >
                      UP TO
                    </span>

                    <span
                      style={{
                        fontSize: 62,
                        fontWeight: 800,
                        lineHeight: 1,
                        margin: "4px 0",
                      }}
                    >
                      60%
                    </span>

                    <span
                      style={{
                        fontSize: 15,
                        fontWeight: 600,
                        opacity: 0.9,
                      }}
                    >
                      OFF
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    );
  };

  // ===================== DIGITAL SCREENS =====================
  // Centered headline, then 3 device-frame mockups of increasing size
  // (32" / 55" / 75") standing side by side.
  const renderDigitalHero = () => {
    const screens = [
      { label: '32" Screen', width: 140, height: 88 },
      { label: '55" Screen', width: 190, height: 118 },
      { label: '75" LED Video Wall', width: 250, height: 150 },
    ];

    return (
      <section style={{ ...heroWrap, textAlign: "center" }}>

        <h1 style={{ fontSize: 40, fontWeight: 800, color: "#0f172a", margin: "0 0 16px", lineHeight: 1.2 }}>
          Reach Customers <span style={{ color: ORANGE }}>In Real Life</span>
        </h1>
        <p style={{ fontSize: 16, color: "#6b7280", maxWidth: 560, margin: "0 auto" }}>
          Put your brand on in-store and mall displays for high-impact visibility
          exactly where customers are standing.
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-end",
            gap: 32,
            marginTop: 50,
            flexWrap: "wrap",
          }}
        >
          {screens.map((s, i) => (
            <div key={i} style={{ textAlign: "center" }}>
              <div
                style={{
                  width: s.width,
                  height: s.height,
                  background: "#111827",
                  borderRadius: 12,
                  padding: 8,
                  boxShadow: cardShadow,
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: 6,
                    background: "linear-gradient(135deg, #fff3ec, #ffd8bb)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <i className="fas fa-play-circle" style={{ fontSize: 22, color: ORANGE }}></i>
                </div>
              </div>
              {/* stand */}
              <div style={{ width: 6, height: 16, background: "#111827", margin: "0 auto" }} />
              <div style={{ width: 44, height: 6, background: "#111827", borderRadius: 3, margin: "0 auto" }} />
              <p style={{ marginTop: 10, fontWeight: 700, fontSize: 14, color: "#1f2937" }}>{s.label}</p>
            </div>
          ))}
        </div>
      </section>
    );
  };

  // ===================== COMBOS =====================
  // Left: headline + description + stats. Right: a "combo receipt" card —
  // itemized list of channels with a dashed total line and savings badge.
  const renderCombosHero = () => {
    const stack = [
      { icon: "fas fa-bell", title: "Popup" },
      { icon: "fas fa-image", title: "Banner" },
      { icon: "fas fa-tag", title: "Deals" },
      { icon: "fas fa-shopping-cart", title: "Checkout" },
    ];

    return (
      <section style={heroWrap}>
        <div style={{ display: "flex", flexWrap: "wrap-reverse", gap: 60, alignItems: "center" }}>
          {/* RIGHT SIDE VISUAL (receipt card) */}


          {/* LEFT SIDE CONTENT */}
          <div style={{ flex: "1 1 380px" }}>
            <span style={eyebrow}>COMBO OFFERS</span>
            <h1 style={{ fontSize: 40, fontWeight: 800, color: "#0f172a", margin: "0 0 16px", lineHeight: 1.2 }}>
              Maximize Value with <span style={{ color: ORANGE }}>Combo</span> Promotions
            </h1>
            <p style={{ fontSize: 16, color: "#6b7280", maxWidth: 460, lineHeight: 1.6 }}>
              Bundle popups, banners, deals and checkout promotions together for
              the best value and the biggest reach — all in one package.
            </p>
            <div style={{ display: "flex", gap: 24, marginTop: 28, flexWrap: "wrap" }}>
              <div>
                <div style={{ fontSize: 26, fontWeight: 800, color: "#0f172a" }}>+300%</div>
                <div style={{ fontSize: 13, color: "#6b7280" }}>Combo Sales</div>
              </div>
              <div>
                <div style={{ fontSize: 26, fontWeight: 800, color: "#0f172a" }}>+65%</div>
                <div style={{ fontSize: 13, color: "#6b7280" }}>Avg. Order Value</div>
              </div>
            </div>
          </div>


          <div style={{ flex: "1 1 320px", display: "flex", justifyContent: "center" }}>
            <div
              style={{
                width: "100%",
                maxWidth: 320,
                background: "#fff",
                borderRadius: 20,
                boxShadow: cardShadow,
                border: "1px solid #f0f0f0",
                overflow: "hidden",
              }}
            >
              {/* header strip */}
              <div
                style={{
                  background: `linear-gradient(135deg, ${ORANGE}, #ff9a5c)`,
                  padding: "18px 24px",
                  color: "#fff",
                }}
              >
                <p style={{ margin: 0, fontSize: 11, letterSpacing: "1px", opacity: 0.9 }}>
                  COMBO PACKAGE
                </p>
                <h4 style={{ margin: "4px 0 0", fontSize: 18, fontWeight: 800 }}>
                  Everything Bundled
                </h4>
              </div>

              {/* itemized list */}
              <div style={{ padding: "20px 24px 8px" }}>
                {stack.map((item, i) => (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                      padding: "10px 0",
                      borderBottom: i < stack.length - 1 ? "1px dashed #eee" : "none",
                    }}
                  >
                    <div
                      style={{
                        width: 34,
                        height: 34,
                        borderRadius: 10,
                        background: "#fff3ec",
                        color: ORANGE,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 14,
                        flexShrink: 0,
                      }}
                    >
                      <i className={item.icon}></i>
                    </div>
                    <span style={{ flex: 1, fontWeight: 600, fontSize: 14, color: "#374151" }}>
                      {item.title}
                    </span>
                    <i className="fas fa-check" style={{ color: ORANGE, fontSize: 12 }}></i>
                  </div>
                ))}
              </div>

              {/* total / savings footer */}
              <div
                style={{
                  margin: "8px 24px 24px",
                  paddingTop: 16,
                  borderTop: "2px dashed #f0c8ae",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span style={{ fontSize: 14, fontWeight: 700, color: "#1f2937" }}>
                  Bundle Total
                </span>
                <span
                  style={{
                    background: "#fff3ec",
                    color: ORANGE,
                    fontWeight: 800,
                    fontSize: 14,
                    padding: "6px 14px",
                    borderRadius: 20,
                  }}
                >
                  Save 30%
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  };


  // Dispatches to the right layout for the active category tab.
  const renderCategoryHero = (tabId) => {
    switch (tabId) {
      case "branding":
        return renderBrandingHero();
      case "leads":
        return renderLeadsHero();
      case "offers":
        return renderOffersHero();
      case "digital":
        return renderDigitalHero();
      case "combos":
        return renderCombosHero();
      default:
        return null;
    }
  };

  return (
    <>
      {!hideOverviewChrome && renderMainTabs()}

      {activeMainTab === "overview" ? (
        // ===================== OVERVIEW TAB =====================
        showPricing ? (

          <Promotionspricingdetails
            feature={selectedFeature}
            onBack={() => setShowPricing(false)}
          />

        ) : (

          <>
            <div style={{ textAlign: "right", marginTop: "-38px" }}>



              <button
                onClick={
                  overviewData.length > 0
                    ? handleEditOverview
                    : handleAddOverview
                }
                style={{
                  padding: "12px 28px",
                  borderRadius: "24px",
                  border: "none",
                  background: ORANGE,
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: "15px",
                  cursor: "pointer",
                  boxShadow: "0 8px 18px rgba(230,109,51,0.35)",
                }}
              >
                {overviewData.length > 0 ? "Edit" : "+ Add"}
              </button>
            </div>
            <section className="promoRoot">
              <div className="promoContainer">

                {/* ================= LEFT SIDE ================= */}

                <div className="promoLeft">

                  {loadingOverview ? (
                    <>
                      <h1 className="promoTitle">
                        Loading...
                      </h1>

                      <p className="promoDesc">
                        Loading promotion information...
                      </p>
                    </>
                  ) : overviewError ? (
                    <>
                      <h1 className="promoTitle">
                        Unable to load
                        <br />
                        <span>Overview</span>
                      </h1>

                      <p className="promoDesc">
                        {overviewError}
                      </p>
                    </>
                  ) : overviewData.length > 0 ? (

                    <>
                      <h1 className="promoTitle">
                        {overviewData[0].title}
                      </h1>

                      <p className="promoDesc">
                        {overviewData[0].description}
                      </p>

                      {/* FEATURES */}

                      {Array.isArray(overviewData[0].featureDescription) &&
                        overviewData[0].featureDescription.length > 0 && (

                          <div className="promoFeatures">

                            {overviewData[0].featureDescription.map(
                              (feature, index) => (
                                <span key={index}>
                                  <i className="fas fa-check-circle"></i>
                                  {feature}
                                </span>
                              )
                            )}

                          </div>
                        )}

                    </>

                  ) : (

                    <>
                      <h1 className="promoTitle">
                        Grow Your Business
                        <br />
                        <span>Faster</span> with Smart
                        <br />
                        Promotions
                      </h1>

                      <p className="promoDesc">
                        Run branding campaigns, generate leads, launch offers,
                        and increase customer engagement through AI-powered
                        marketing tools — all in one place.
                      </p>

                      <div className="promoFeatures">

                        <span>
                          <i className="fas fa-check-circle"></i>
                          No setup fees
                        </span>

                        <span>
                          <i className="fas fa-check-circle"></i>
                          Cancel anytime
                        </span>

                        <span>
                          <i className="fas fa-check-circle"></i>
                          AI optimised
                        </span>

                      </div>
                    </>
                  )}

                </div>


                {/* ================= RIGHT SIDE ================= */}

                <div className="promoRight">

                  <div className="analyticsCard">

                    {/* HEADER */}

                    <div className="cardHeader">

                      <div>
                        <p>AD PERFORMANCE</p>

                        <h2>
                          +342% Reach
                        </h2>
                      </div>

                      <div className="liveBadge">
                        Live
                      </div>

                    </div>


                    {/* IMAGE / CHART */}

                    {overviewData.length > 0 &&
                      Array.isArray(overviewData[0].imageUrls) &&
                      overviewData[0].imageUrls.length > 0 ? (

                      <div
                        style={{
                          width: "100%",
                          height: "260px",
                          overflow: "hidden",
                          borderRadius: "14px",
                        }}
                      >
                        <img
                          src={overviewData[0].imageUrls[0]}
                          alt={overviewData[0].title || "Overview"}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block",
                          }}
                        />
                      </div>

                    ) : (

                      <PromotionChart />

                    )}


                    {/* FLOATING CARD */}

                    <div className="floatingCard">

                      <div className="iconCircle">
                        <i className="fas fa-arrow-up"></i>
                      </div>

                      <div>

                        <p>Vendor Success</p>

                        <h4>
                          +120% Orders
                        </h4>

                      </div>

                    </div>

                  </div>

                </div>

              </div>
            </section>


            <AddNewModal
              show={showAddModal}
              isEditMode={isEditMode}
              selectedOverview={selectedOverview}
              onClose={() => {
                setShowAddModal(false);
                setIsEditMode(false);
                setSelectedOverview(null);
              }}
              onSubmit={async (data) => {

                try {

                  //console.log("Modal submitted:", data);

                  /*
                   data structure:
                   {
                      title,
                      description,
                      image,
                      extraFields
                   }
                  */

                  if (isEditMode && selectedOverview) {

                    // =========================
                    // UPDATE
                    // =========================

                    const overviewId = selectedOverview.id;

                   

                    const updateData = {
                      id: overviewId,
                      title: data.title,
                      description: data.description,
                      type: "OVERVIEW",

                      featureDescription:
                        data.extraFields || [],
                    };

                    const imageFiles = data.image
                      ? [data.image]
                      : [];

                    await PromotionsService.updateOverview(
                      overviewId,
                      updateData,
                      imageFiles
                    );

                    

                  } else {

                    // =========================
                    // CREATE
                    // =========================

                    const createData = {
                      title: data.title,
                      description: data.description,
                      type: "OVERVIEW",

                      featureDescription:
                        data.extraFields || [],
                    };

                    const imageFiles = data.image
                      ? [data.image]
                      : [];

                    await PromotionsService.createOverview(
                      createData,
                      imageFiles
                    );

                  }

                  // Refresh API data
                  await fetchOverviewData();

                  // Close modal
                  setShowAddModal(false);

                  setIsEditMode(false);
                  setSelectedOverview(null);

                  setAddFormData({
                    title: "",
                    description: "",
                    image: null,
                  });

                  setImagePreview(null);

                } catch (error) {

                  console.error(
                    isEditMode
                      ? "Failed to update overview:"
                      : "Failed to create overview:",
                    error.response?.data || error
                  );

                }

              }}
            />
            {/* <PromotionFeatures
              onExplore={handleExplore}
            /> */}

            <PromotionFeaturesgroth
              onGetStarted={() => onNavigate("PRICING")}
            />
          </>
        )
      ) : (
        // ============ BRANDING / LEADS / OFFERS / DIGITAL / COMBOS TABS ============
        // No "feature" is passed, so all plans in that category render.
        // controlledTab / hideOwnTabs stop it from drawing its own duplicate tab row.
        <>
          {!hideOverviewChrome && (
            <>
              <div
                style={{
                  textAlign: "right",
                  padding: "16px 24px 0",
                  marginTop: "-48px",
                }}
              >
                <button
                  onClick={() => {
                    const activeData = getActiveCategoryData();

                    if (activeData.length > 0) {
                      setIsEditMode(true);
                      setSelectedOverview(activeData[0]);
                    } else {
                      setIsEditMode(false);
                      setSelectedOverview(null);
                    }

                    setShowCategoryAddModal(true);
                  }}
                  style={{
                    padding: "12px 28px",
                    borderRadius: "24px",
                    border: "none",
                    background: ORANGE,
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: "15px",
                    cursor: "pointer",
                    boxShadow: "0 8px 18px rgba(230,109,51,0.35)",
                  }}
                >
                  {getActiveCategoryData().length > 0 ? "Edit" : "+ Add"}
                </button>
              </div>

              {renderCategoryHero(activeMainTab)}
            </>
          )}



          <AddNewModal
            show={showCategoryAddModal}
            isEditMode={isEditMode}
            selectedOverview={selectedOverview}
            onClose={() => {
              setShowCategoryAddModal(false);
              setIsEditMode(false);
              setSelectedOverview(null);
            }}
            onSubmit={async (data) => {
              try {
                const typeForTab =
                  activeMainTab === "branding"
                    ? "BRANDING"
                    : activeMainTab.toUpperCase();


                if (isEditMode && selectedOverview) {
                  // =========================
                  // UPDATE
                  // =========================

                  const overviewId = selectedOverview.id;

                  const updateData = {
                    id: overviewId,
                    title: data.title,
                    description: data.description,
                    type: typeForTab,
                    featureDescription: data.extraFields || [],
                  };

                  const imageFiles = data.image
                    ? [data.image]
                    : [];

                  await PromotionsService.updateOverview(
                    overviewId,
                    updateData,
                    imageFiles
                  );


                } else {
                  // =========================
                  // CREATE
                  // =========================

                  const createData = {
                    title: data.title,
                    description: data.description,
                    type: typeForTab,
                    featureDescription: data.extraFields || [],
                  };

                  const imageFiles = data.image
                    ? [data.image]
                    : [];

                  await PromotionsService.createOverview(
                    createData,
                    imageFiles
                  );

                  //console.log("Branding created successfully");
                }

                // Refresh Branding data
                if (activeMainTab === "branding") {
                  await fetchBrandingData();
                } else {
                  await fetchOverviewData();
                }

                // Close modal
                setShowCategoryAddModal(false);
                setIsEditMode(false);
                setSelectedOverview(null);

              } catch (error) {
                console.error(
                  isEditMode
                    ? "Failed to update branding:"
                    : "Failed to create branding:",
                  error?.response?.data || error
                );
              }
            }}
          />


          <div style={{ padding: "20px" }}>
            <Pricingsectionparticular
              feature={null}
              pricingMode="fixed"
              controlledTab={activeMainTab}
              hideOwnTabs={true}
              hideParentBack={() => setHideOverviewChrome(true)}
              showParentBack={() => setHideOverviewChrome(false)}
              hideParentTabs={() => setHideOverviewChrome(true)}
              showParentTabs={() => setHideOverviewChrome(false)}
            />
          </div>
        </>
      )}
    </>
  );
};

export default Overview;
